import { Pipe, type PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeSrc',
})
export class SafeSrcPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: any) {
    // note: the sanitizer does not accept (our?) attachment urls when using SecurityContext.RESOURCE_URL (unclear why, there seems to be no documentation on what the criteria are, also could not figure it out from the angular source code)
    // we still want to sanitize the url using the normal SecurityContext.URL, to filter out javascript: etc.
    const sanitizedURL = this.sanitizer.sanitize(SecurityContext.URL, url);
    // after that, we call bypass so the type will be accepted by iframe[src]
    // @ts-expect-error TS2345 argument not assignable
    const trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedURL);
    return trustedUrl;
  }
}
